import { get } from 'lodash-es';
import { ClientConfig } from 'client/configuration';
import { CapOneAPI, CapOneAPIV2 } from 'client/data/api/cap-one-api';
import { CLIENT_ARTIFACT } from 'client/data/api/api-metrics';
import { isAvailableEnvToBypassApiGateway } from 'site-modules/shared/utils/financing/is-available-env-to-bypass-api-gateway';

export function getMetricHeaders(state) {
  const metricHeaders = {
    'x-artifact-id': CLIENT_ARTIFACT,
  };

  const pageName = get(state, 'pageContext.page.name');
  const pageCategory = get(state, 'pageContext.page.category');
  const venomVersion = get(state, 'venomVersion.version');
  const xHeaders = get(state, 'xHeaders');
  const protocol = get(state, 'request.protocol');
  const hostName = get(state, 'request.hostName');
  const url = get(state, 'request.url');

  if (pageName) metricHeaders['x-edw-page-name'] = pageName;
  if (pageCategory) metricHeaders['x-edw-page-cat'] = pageCategory;
  if (xHeaders['x-trace-seq']) metricHeaders['x-trace-seq'] = xHeaders['x-trace-seq'];

  metricHeaders['x-referer'] = `${protocol}://${hostName}${url}`;
  metricHeaders['x-artifact-version'] = venomVersion;
  metricHeaders['x-trace-id'] = xHeaders['x-trace-id'];

  return metricHeaders;
}

export function geApiOptions(state) {
  return {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'x-api-key': ClientConfig.get('carBuying').xApiKey,
      'x-visitor-id': get(state, 'visitor.id'),
      ...getMetricHeaders(state),
    },
    timeout: ClientConfig.get('carBuying').capOneAPI.apiTimeoutMs,
    showAPIError: true,
    retries: 0,
  };
}

export function getConfigOptions(state) {
  const isCapOneBypassApiGateway = get(state, 'featureFlags.capOneBypassApiGateway', false);
  const isAllowBypassApiGateway =
    isAvailableEnvToBypassApiGateway({ venomEnv: get(state, 'venomEnv'), edmundsEnv: get(state, 'edmundsEnv') }) &&
    isCapOneBypassApiGateway;

  return {
    CapitalOneAPI: isAllowBypassApiGateway ? CapOneAPIV2 : CapOneAPI,
    isDisableAWSAuth: ClientConfig.get('carBuying').capOneAPI.disableAWSAuth,
    isAllowBypassApiGateway,
    baseUrl: isAllowBypassApiGateway
      ? ClientConfig.get('carBuying').capOneApiUrlBypassApiGateway
      : ClientConfig.get('carBuying').capOneApiUrl,
  };
}

export function getConfigOptionsV2(isAllowBypassApiGateway) {
  return {
    isDisableAWSAuth: ClientConfig.get('carBuying').capOneAPI.disableAWSAuth,
    isAllowBypassApiGateway,
    baseUrl: isAllowBypassApiGateway
      ? ClientConfig.get('carBuying').capOneApiUrlBypassApiGateway
      : ClientConfig.get('carBuying').capOneApiUrl,
  };
}
